<!-- Hero Slider -->

<div class="hero-slider owl-carousel owl-theme">
  <div class="hero-slider-item item-bg1">
    <div class="d-table">
      <div class="d-table-cell">
        <div class="container">
          <div class="banner-content">
            <!-- <span>Since 1992</span> -->
            <h2>Welcome to</h2>
            <h2>TVT Logistics India</h2>
            <h2>The Vantage Tradelink</h2>
            <p>New Era Of Total Logistic Solutions</p>
            <a routerLink="/contact" class="default-btn-two">Contact Us</a>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="hero-slider-item item-bg2">
    <div class="d-table">
      <div class="d-table-cell">
        <div class="container">
          <div class="banner-content">
            <h2>Welcome to</h2>
            <h2>TVT Logistics India</h2>
            <h2>The Vantage Tradelink</h2>
            <p>New Era Of Total Logistic Solutions</p>
            <a routerLink="/contact" class="default-btn-two">Contact Us</a>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="hero-slider-item item-bg3">
    <div class="d-table">
      <div class="d-table-cell">
        <div class="container">
          <div class="banner-content">
            <h2>Welcome to</h2>
            <h2>TVT Logistics India</h2>
            <h2>The Vantage Tradelink</h2>
            <p>New Era Of Total Logistic Solutions</p>
            <a routerLink="/contact" class="default-btn-two">Contact Us</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- End Hero Slider -->

<!-- About Area -->
<div class="about-area pb-70">
  <div class="container">
    <div class="row">
      <div class="col-lg-4 col-md-12">
        <div class="about-contant">
          <div class="section-title">
            <span>About Us</span>
            <h2>Safe And Faster Logistic Service Near You</h2>
          </div>
          <div class="about-text">
            <p>
              We are well known company in the areas of international and
              domestic cargo services with a vision to offer complete logistic
              services to corporate and many other business establishments in
              various fields of business and all type of segments. We have a
              corporate vision to be recognized among the best of logistic
              companies of the time. By this we mean to uphold the expectations
              in areas of service that our valued customers hold from us and
              better it every time.
            </p>
            <a routerLink="/" class="default-btn-one btn-bs">Learn More</a>
          </div>
        </div>
      </div>

      <div class="col-lg-5 col-md-12">
        <div class="about-image">
          <img src="assets/img/about/about1.jpg" alt="about-image" />
        </div>
      </div>

      <div class="col-lg-3 col-md-12">
        <div class="about-tabs">
          <div class="tab-contant">
            <h2 class="title">Our Key Focus</h2>

            <div class="tab-content" id="nav-tabContent">
              <div
                class="tab-pane fade show active"
                id="nav-vision"
                role="tabpanel"
              >
                <div class="vision">
                  <ul>
                    <li>
                      <i class="bx bx-check"></i> Freight Forwarding Air & Sea
                      (Export & Import)
                    </li>
                    <li><i class="bx bx-check"></i> Domestic Logistics</li>
                    <li><i class="bx bx-check"></i> Custom Clearance</li>
                    <li><i class="bx bx-check"></i> Break Bulk</li>
                    <li><i class="bx bx-check"></i> Transport</li>
                    <li>
                      <i class="bx bx-check"></i> Worldwide DDU/ DDP by Air/ Sea
                      (FCL/ LCL)
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- End About Area -->

<div class="freight-area freight-area-two pt-70">
  <div class="container">
    <div class="section-title">
      <span>Our Services</span>
      <h2>We Feeling The Joy Of Serving You Best</h2>
    </div>
    <br />
    <br />
    <div class="freight-area pb-70">
      <div class="container">
        <div class="freight-inner">
          <div class="row">
            <div class="col-lg-4 col-md-6">
              <div class="service-card-two">
                <img
                  class="freight-image"
                  src="assets/img/freight/freight1.jpg"
                  alt="image"
                />
                <div class="service-caption">
                  <h3>Sea / Air Freight</h3>
                  <p>
                    The alternative to the speed of air freight and the low cost
                    of ocean freight is a combination of both.
                  </p>
                  <a
                    routerLink="/services"
                    class="default-btn-two"
                    fragment="sea"
                    >Read More</a
                  >
                </div>
              </div>
            </div>

            <div class="col-lg-4 col-md-6">
              <div class="service-card-two">
                <img
                  class="freight-image"
                  src="assets/img/freight/freight2.jpg"
                  alt="image"
                />
                <div class="service-caption">
                  <h3>Break Bulk</h3>
                  <p>
                    Types of goods that are commonly transported in a break bulk
                    shipment include timber, steel slabs, paper pulp...
                  </p>
                  <a
                    routerLink="/services"
                    class="default-btn-two"
                    fragment="break-bulk"
                    >Read More</a
                  >
                </div>
              </div>
            </div>

            <div class="col-lg-4 col-md-6 offset-md-3 offset-lg-0">
              <div class="service-card-two">
                <img
                  class="freight-image"
                  src="assets/img/freight/freight3.jpg"
                  alt="image"
                />
                <div class="service-caption">
                  <h3>Surface Transportation</h3>
                  <p>
                    Cargocare operates a Fleet of vehicle in India for delivery
                    of consignment at the customer’s doorstep.
                  </p>
                  <a
                    routerLink="/services"
                    class="default-btn-two"
                    fragment="surface-transportation"
                    >Read More</a
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Choose Area -->
<div class="choose-area ptb-70">
  <div class="shape-one">
    <img src="assets/img/shape/shape5.png" alt="Shape" />
  </div>

  <div class="container">
    <div class="row align-items-center">
      <div class="col-lg-6 col-md-6">
        <div class="choose-contant">
          <div class="choose-card">
            <i class="bx bx-world"></i>
            <h3>Worldwide Service</h3>
            <p>
              We serve our service to America, U.K ., Australia , New Zealand ,
              Canada , Europe ,Gulf & Upper Gulf & All Africa .
            </p>
          </div>
        </div>

        <div class="choose-contant">
          <div class="choose-card">
            <i class="bx bxs-paper-plane"></i>
            <h3>Tracking Service</h3>
            <p>
              Customers get time to time update about there cargo on website
            </p>
          </div>
        </div>

        <div class="choose-contant">
          <div class="choose-card">
            <i class="bx bxs-truck"></i>
            <h3>Fast and Reliable</h3>
            We are as fast as air and as trustworthy as your heart with reliable
            service.
          </div>
        </div>

        <div class="choose-contant">
          <div class="choose-card">
            <i class="bx bx-support"></i>
            <h3>24/7 Support</h3>
            <p class="support-text">cs@thevantagetradelink.in</p>
            <p>079 48970015/13 /12</p>
          </div>
        </div>
      </div>

      <div class="col-lg-6 col-md-6">
        <div class="choose-text">
          <div class="section-title">
            <span>Why Choose Us</span>
            <h2>The right choice for you</h2>
          </div>
          <p>
            We are well known company in the areas of international and domestic
            cargo services with a vision to offer complete logistic services to
            corporate and many other business establishments in various fields
            of business and all type of segments. We have a corporate vision to
            be recognized among the best of logistic companies of the time. By
            this we mean to uphold the expectations in areas of service that our
            valued customers hold from us and better it every time.
          </p>
          <a routerLink="/contact" class="default-btn-one">Contact Us</a>
          <div class="shape-image">
            <img src="assets/img/shape/shape2.png" alt="icon" />
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- End Choose Area -->
